import React, { useState, useEffect } from "react";
import "./barathivizha.css";
import Loader from "./Loader.jsx";

const Barathivizha = () => {
  // Initialize as empty array instead of boolean
  const [portfolioData, setPortfolioData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/barathivizha.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);

        // Make sure data.portfolioData exists before setting it
        if (data.portfolioData) {
          setPortfolioData(data.portfolioData);
        } else {
          throw new Error("portfolioData not found in response");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Only try to get categories if portfolioData is loaded
  const allCategories =
    portfolioData.length > 0
      ? ["all", ...new Set(portfolioData.map((item) => item.category))]
      : ["all"];

  const [activeCategory, setActiveCategory] = useState("all");

  const filteredItems =
    activeCategory === "all"
      ? portfolioData
      : portfolioData.filter((item) => item.category === activeCategory);

  if (loading) return <Loader />;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="portfolio-container1">
      <h1>பாரதிவிழா</h1>
      <div className="category-scroll-container1">
        <div className="breadcrumbs1">
          {allCategories.map((category) => (
            <button
              key={category}
              className={`breadcrumb1 ${
                activeCategory === category ? "active" : ""
              }`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      <div className="portfolio-list1">
        {filteredItems.map((item) => (
          <div key={item.id} className="portfolio-item1">
            <div className="item-info">
              <h3>"பாரதி விழா - {item.title}"</h3>
              <p>{item.description}</p>
            </div>
            {item.imagee && item.imagee.length > 0 && (
              <div className="item-images1">
                {item.imagee.map((imageUrl, index) => (
                  <img
                    key={index}
                    src={imageUrl}
                    alt={`Event image ${index + 1}`}
                    className="portfolio-image1"
                  />
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Barathivizha;
